export enum CandidateSuitabilityType {
    Hot = 1,
    Medium = 2,
    Cool = 3
}